var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('h5',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('rooms.soldOut.availabilityAdded')))]),_c('p',{staticClass:"content"},[_vm._v(_vm._s(_vm.$t('rooms.soldOut.addMoreRooms')))])])}
var staticRenderFns = []

export { render, staticRenderFns }